import React, { useState, useEffect, useRef } from 'react';
import { FixedSizeList as List } from 'react-window';
import { Button, FormControl, InputGroup, Modal, Spinner } from 'react-bootstrap';
import './FileViewer.css';
import { Notify } from '../../../Helpers/notification';
import { PROXY_URL } from '../../../Helpers/constant';

const FileViewer = ({ url, onClose }) => {
  const [lines, setLines] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [highlightedLine, setHighlightedLine] = useState(null);
  const [lineNumber, setLineNumber] = useState('');
  const listRef = useRef();

  useEffect(() => {
    if (!url) return;

    const fetchFile = async () => {
      try {
        setLoading(true);
        // const response = await fetch(PROXY_URL, {
        const response = await fetch(PROXY_URL + "/proxy", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            url: url, // original file URL
            method: "GET"
          })
        });
        if (!response.ok) throw new Error('Failed to fetch file');
        
        const result = await response.json();

        if (result.data) {
          const fileContent = typeof result.data === "string" ? result.data : JSON.stringify(result.data, null, 2);
          setLines(fileContent.trimEnd().split('\n'));
        } else {
          throw new Error("No data received from proxy");
        }

      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchFile();
  }, [url]);

  const goToLine = () => {
    const lineNum = Number.parseInt(lineNumber, 10);
    if (Number.isNaN(lineNum) || lineNum < 1 || lineNum > lines.length) {
      Notify.notify(`Please enter a valid line number (1-${lines.length})`);
      return;
    }

    const index = lineNum - 1;
    setHighlightedLine(index);
    
    if (listRef.current) {
      listRef.current.scrollToItem(index, 'start');
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      goToLine();
    }
  };

  const Row = ({ index, style }) => {
    const isHighlighted = highlightedLine === index;
    
    return (
      <div 
        className={`file-line ${isHighlighted ? 'highlighted-line' : ''}`} 
        style={style}
      >
        <span className="line-number">{index + 1}.  </span>
        <span className="line-content">
          {lines[index]}
        </span>
      </div>
    );
  };

  return (
    <Modal 
      show={true} 
      onHide={onClose}
      size="lg"
      centered
      className="file-viewer-modal"
      dialogClassName="file-viewer-dialog"
    >
      <Modal.Header closeButton>
        <Modal.Title>Base File Viewer</Modal.Title>
      </Modal.Header>
      
      <Modal.Body>
        {loading && (
          <div className="text-center p-4">
            <Spinner/>
          </div>
        )}
        
        {error && (
          <div className="alert alert-danger alert-sm">
            Error loading file: {error}
          </div>
        )}
        
        {!loading && !error && (
          <>
            <InputGroup className="mb-2">
              <FormControl
                placeholder="Line number"
                value={lineNumber}
                onChange={(e) => setLineNumber(e.target.value)}
                onKeyDown={handleKeyPress}
                size="sm"
              />
              <Button 
                variant="primary" 
                onClick={goToLine}
                size="sm"
              >
                Go
              </Button>
            </InputGroup>
            
            <div className="file-container">
              {lines.length === 0 ? (
                <div className="text-center p-2 text-muted small">
                  Empty file
                </div>
              ) : (
                <List
                  ref={listRef}
                  height={300}
                  itemCount={lines.length}
                  itemSize={24}
                  width="100%"
                >
                  {Row}
                </List>
              )}
            </div>
            
            <div className="text-muted small mt-1">
              Total lines: {lines.length}
            </div>
          </>
        )}
      </Modal.Body>
      
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose} size="sm">
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default FileViewer;